import type { ActiveScope } from '@/lib/map/state/mapState';

/**
 * AK-296 (deep-link scope restore): read `?farm=<uuid>` / `?cluster=<uuid>`
 * from the current URL into an ActiveScope.
 *
 * `persistScopeUrl` in `pages/map/v2.tsx` (the chip-click side-effect) WRITES
 * these params so map links are shareable, but on mount the hydrate effect only
 * seeded scope from the server pointer (`/scope/available`). So opening a shared
 * link landed on the server's last scope, not the link's. The hydrate effect now
 * consults this parser FIRST and only falls back to the server pointer when no
 * scope param is present.
 *
 * Lives in its own maplibre-free module so it stays unit-testable under jsdom
 * (importing `pages/map/v2.tsx` pulls in maplibre-gl, which cannot load in the
 * test environment).
 *
 * Returns null when neither param is present. `farm` wins over `cluster` if both
 * are somehow present (the more specific scope).
 */
export function scopeFromUrl(): ActiveScope | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const farm = params.get('farm');
  if (farm) return { type: 'farm', id: farm };
  const cluster = params.get('cluster');
  if (cluster) return { type: 'cluster', id: cluster };
  return null;
}
